import { Component, OnInit } from '@angular/core';
import { PdfGenerationService } from '@app/_services';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-pdftemplate',
  templateUrl: './pdftemplate.component.html',
  styleUrls: ['./pdftemplate.component.less']
})
export class PdftemplateComponent implements OnInit {
  templateType: any;
  pdfModel: string;
  token: string;
  hasData: boolean;
  constructor(
    private pdfService: PdfGenerationService,
    private Activatedroute: ActivatedRoute,
  ) { 
    this.token = this.Activatedroute.snapshot.paramMap.get("token");
  }

  ngOnInit(): void {
    this.handleToken(this.token);
  }

  handleToken(token: string): any{
    this.pdfService.validateToken(token).subscribe(data => this.HandlePDFType(data))
  }

  HandlePDFType(data: any): void{
    this.templateType = data.TemplateType;
    this.pdfModel = data;
    this.hasData = true;
  }
}
